// extracted by mini-css-extract-plugin
export var infoSection = "_o-1";
export var infoSectionContainer = "_o-0";
export var infoSectionTitleRow = "_o-2";
export var multiLineInfo = "_o-4";
export var strong = "_o-3";